/**
 * @fileoverview Agent definition for the character-extractor-full-v2 primitive.
 *
 * This agent reads a document and extracts a comprehensive list of all characters
 * with detailed attributes including physical appearance, personality, and role.
 *
 * @category import.characters.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'character-extractor-full-v2',
  kind: 'primitive',
  name: 'Full Character Extractor',
  description: 'Reads a document and extracts a comprehensive list of all characters with detailed attributes.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2025-01',
    taxonomyPath: 'import.characters.extraction',
    usedBy: ['ImportStoryDialog', 'use-import-story.ts'],
    relatedAgents: ['character-extractor-targeted-v2'],
  },
};
